import axios from 'axios';
import * as config from 'core/config';

export const restRequest = axios.create({
  baseURL: config.apiRest.baseURL,
});

export const actionRequest = axios.create({
  baseURL: config.apiDashboard.baseURL,
});
